import { Fragment } from 'preact';

const nodes = [
  { label: 'CLI / Desktop', desc: 'User interface layer' },
  { label: 'Backend', desc: 'Orchestration + memory' },
  { label: 'Inference', desc: 'GPU model server' },
  { label: 'Vector DB', desc: 'Embeddings + RAG' },
];

function Architecture() {
  return (
    <section class="section" id="architecture">
      <div class="container">
        <div class="section-header">
          <span class="tag">Under the hood</span>
          <h2>Four modules, one platform</h2>
        </div>
        <p class="text-center text-muted max-w-[560px] mx-auto mb-10 text-[0.95rem]">
          Four independent Go modules communicate via JSON over HTTP. Run them as a
          hosted GPU platform, or embed everything in a single local binary — same
          architecture, your choice of where it lives.
        </p>
        <div class="flex items-center justify-center gap-2 flex-wrap px-8 py-12 glass max-md:flex-col">
          {nodes.map((node, i) => (
            <Fragment key={node.label}>
              <div class="px-6 py-4 text-center min-w-[140px]">
                <div class="font-mono text-[0.75rem] text-accent uppercase tracking-[0.06em] mb-[0.35rem]">
                  {node.label}
                </div>
                <div class="text-[0.8rem] text-muted">{node.desc}</div>
              </div>
              {i < nodes.length - 1 && (
                <span class="text-border text-2xl font-light max-md:rotate-90">→</span>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Architecture;
